import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";


const PaymentPage = () => {
  const navigate = useNavigate();
  const [selectedMethod, setSelectedMethod] = useState("cod");
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState([]);
  const [subtotal, setSubtotal] = useState("0.00");
  const [totalDiscount, setTotalDiscount] = useState("0.00");
  const [grandTotal, setGrandTotal] = useState("0.00");
  const selectedAddressId = localStorage.getItem("selected_address_id");



  const user_id = localStorage.getItem("user_id");
  const location = useLocation();
  const orderId = location.state?.order_id;
  console.log("➡️ Navigating with orderId:", orderId);


  const handleSelect = (method) => {
    setSelectedMethod(method);
  };

  const paymentMethods = [
    { id: "cod", label: "Cash On Delivery (Cash/UPI)", apiValue: "Cash" },
    { id: "upi", label: "UPI (Pay via any App)", apiValue: "UPI" },
    { id: "card", label: "Credit/Debit Card", apiValue: "Card" },
    { id: "paylater", label: "Pay Later", apiValue: "Pay Later" },
    { id: "wallets", label: "Wallets", apiValue: "Wallet" },
  ];

  useEffect(() => {
  if (user_id) fetchCart();
}, [user_id]);


  // -----------------------------
  // FETCH SELLER DETAILS
  // -----------------------------
  const fetchSellerDetails = async (sellerId) => {
    try {
      const formData = new FormData();
      formData.append("seller_id", sellerId);

      const res = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/get_by_id_seller_registration",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.status === true || res.data.status === "true") {
        return res.data.data;
      }
      return null;
    } catch (err) {
      console.error("Fetch Seller Error:", err);
      return null;
    }
  };

  // -----------------------------
  // FETCH BUYER/CONTACT DETAILS
  // -----------------------------
  const fetchBuyerDetails = async (contactId) => {
    try {
      const formData = new FormData();
      formData.append("contact_id", contactId);

      const res = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/get_by_id_contact_details_address",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.status === true || res.data.status === "true") {
        return res.data.data;
      }
      return null;
    } catch (err) {
      console.error("Fetch Buyer Error:", err);
      return null;
    }
  };

  // -----------------------------
  // CREATE INVOICE API
  // -----------------------------
  const createInvoice = async (orderData) => {
    try {
      console.log("🔵 Starting invoice creation for order:", orderData);

      const sellerId = orderData.items[0]?.seller_id;
      const contactId = orderData.contact_id;

      console.log("🔵 Seller ID:", sellerId);
      console.log("🔵 Contact ID:", contactId);

      // Fetch seller and buyer details
      console.log("🔵 Fetching seller and buyer details...");
      const [sellerDetails, buyerDetails] = await Promise.all([
        fetchSellerDetails(sellerId),
        fetchBuyerDetails(contactId)
      ]);

      console.log("🔵 Seller Details:", sellerDetails);
      console.log("🔵 Buyer Details:", buyerDetails);

      // Prepare product items from order data
      const productItems = orderData.items.map(item => ({
        product_name: item.product_name,
        size: item.size || "N/A",
        qty: item.qty,
        price: parseFloat(item.price),
        tax: parseFloat((item.price * 0.18).toFixed(2)), // 18% tax calculation
        total: parseFloat((item.price * item.qty * 1.18).toFixed(2))
      }));

      console.log("🔵 Product Items:", productItems);

      // Calculate totals
      const subTotal = productItems.reduce((sum, item) => sum + (item.price * item.qty), 0);
      const estimatedTax = productItems.reduce((sum, item) => sum + item.tax, 0);
      const grandTotal = subTotal + estimatedTax;

      console.log("🔵 Calculations - SubTotal:", subTotal, "Tax:", estimatedTax, "Grand Total:", grandTotal);

      // Prepare FormData for invoice
      const formData = new FormData();
      formData.append("order_id", orderData.order_id);
      formData.append("seller_id", sellerId || "");
      formData.append("contact_id", contactId);
      
      // Sender info (from seller)
      formData.append("sender_name", sellerDetails?.business_name || "Store");
      formData.append("sender_address", sellerDetails?.address || "");
      formData.append("sender_number", sellerDetails?.mobile || "");
      
      // Invoice details
      formData.append("invoice_no", `INV-${new Date().getFullYear()}-${orderData.order_id.toString().padStart(3, '0')}`);
      formData.append("issue_date", new Date().toISOString().split('T')[0]);
      formData.append("due_date", new Date(Date.now() + 12 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]);
      formData.append("amount", grandTotal.toFixed(2));
      const invoiceStatus =
  orderData.order_status ||
  (orderData.payment_mode === "Cash" ? "abandoned" : "confirmed");

formData.append("status", invoiceStatus);
console.log("🔵 Invoice Status:", invoiceStatus);


      
      // Buyer info (from contact)
      formData.append("buyer_from", buyerDetails?.name || orderData.contact_name || "");
      formData.append("buyer_address", buyerDetails?.address || orderData.contact_full_address || "");
      formData.append("buyer_number", buyerDetails?.phone || orderData.contact_phone || "");
      formData.append("buyer_email", buyerDetails?.email || "");
      
      // Issuer info (from seller)
      formData.append("issuer_from", sellerDetails?.business_name || "Store");
      formData.append("issuer_address", sellerDetails?.address || "");
      formData.append("issuer_number", sellerDetails?.mobile || "");
      formData.append("issuer_email", sellerDetails?.email || "");
      
      // Product details - product_items contains all product info including image path
      formData.append("product_items", JSON.stringify(productItems));
      
      // Totals
      formData.append("sub_total", subTotal.toFixed(2));
      formData.append("discount", "0.00");
      formData.append("estimated_tax", estimatedTax.toFixed(2));
      formData.append("grand_total", grandTotal.toFixed(2));

      // Log all FormData entries
      console.log("🔵 FormData entries:");
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      console.log("🔵 Sending invoice API request...");
      const invoiceRes = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/add_invoice",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      console.log("🔵 Invoice API Response:", invoiceRes.data);

      if (invoiceRes.data.status === "true" || invoiceRes.data.status === true) {
        console.log("✅ Invoice created successfully for Order ID:", orderData.order_id);
        toast.success("Invoice created successfully!");
      } else {
        console.warn("⚠️ Invoice creation failed:", invoiceRes.data.message);
        toast.warn("Invoice creation failed: " + invoiceRes.data.message);
      }
    } catch (err) {
      console.error("❌ Invoice Creation Error:", err);
      console.error("❌ Error Response:", err.response?.data);
      toast.error("Invoice creation error: " + (err.response?.data?.message || err.message));
      // Don't throw error - invoice creation failure shouldn't stop order flow
    }
  };

  // -----------------------------
  // PLACE ORDER API
  // -----------------------------
  const placeOrder = async () => {
    console.log("Button is hitting");
    
    if (!selectedAddressId) {
      toast.error("Address not selected");
      return;
    }

    setLoading(true);

    const getPaymentDetails = () => {
  switch (selectedMethod) {
    case "cod":
      return {
        payment_mode: "Cash",
        payment_status: "Pending",
        order_status: "abandoned",
      };

    case "paylater":
      return {
        payment_mode: "Online",
        payment_status: "Pending",
        order_status: "Pending",
      };

    case "upi":
      return {
        payment_mode: "UPI",
        payment_status: "Paid",
        order_status: "Confirmed",
      };

    case "card":
      return {
        payment_mode: "Card",
        payment_status: "Paid",
        order_status: "Confirmed",
      };

    case "wallets":
      return {
        payment_mode: "Online",
        payment_status: "Paid",
        order_status: "Confirmed",
      };

    default:
      return {
        payment_mode: "Cash",
        payment_status: "Pending",
        order_status: "Pending",
      };
  }
};


const { payment_mode, payment_status, order_status } = getPaymentDetails();

const payload = {
  user_id: user_id,
  contact_id: selectedAddressId,
  payment_mode: payment_mode,
  payment_status: payment_status,
  order_status: order_status,
};



    try {
      const res = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/place_order",
        payload
      );

      console.log("Place Order Response:", res.data);

      if (res.data.status === "true" || res.data.success === "1") {
        const orderData = res.data.data?.[0] || res.data.order;
        const orderId = orderData?.order_id;
        const orderNumber = orderData?.order_no || orderData?.order_number;

        if (!orderId) {
          console.error("Order ID not found in response:", res.data);
          toast.error("Order ID not received");
          setLoading(false);
          return;
        }

        console.log("✅ Order placed successfully:", { orderId, orderNumber });

        // ✅ Create invoice for the order
        await createInvoice(orderData);

        // ✅ Store order details in localStorage
        localStorage.setItem("last_order_id", orderId);
        if (orderNumber) {
          localStorage.setItem("last_order_number", orderNumber);
        }

        // ✅ Clear cart-related data after successful order
        localStorage.removeItem("selected_address_id");

        toast.success("Order placed successfully! 🎉");

        // ✅ Pass complete order details to confirmation page
        // Note: Use items[] array for product details
        navigate("/order-confirmed", {
          state: { 
            order_id: orderId,
            order_number: orderNumber,
            order_details: orderData
          },
        });
      } else {
        toast.error(res.data.message || "Order placement failed");
      }
    } catch (err) {
      console.error("Place Order Error:", err);
      toast.error(err.response?.data?.message || "Failed to place order. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  // -----------------------------
// FETCH CART FOR PAYMENT PAGE
// -----------------------------
const fetchCart = async () => {
  try {
    const formData = new FormData();
    formData.append("user_id", user_id);

    const res = await axios.post(
      "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_cart",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (res.data?.status === true || res.data?.status === "true") {
      const cartData = res.data.data.map((item) => {
        let parsedImage = [];

        if (Array.isArray(item.multi_image) && item.multi_image.length > 0) {
          const imgValue = item.multi_image[0];
          parsedImage = imgValue.startsWith("[")
            ? JSON.parse(imgValue)
            : [imgValue];
        }

        return { ...item, parsedImage };
      });

      setCart(cartData);
      setSubtotal(res.data.subtotal || "0.00");
      setTotalDiscount(res.data.total_discount || "0.00");
      setGrandTotal(res.data.grand_total || "0.00");
    }
  } catch (err) {
    console.error("Payment Cart Fetch Error:", err);
  }
};


  return (
    <div>
      {/* HEADER */}
      <div className="bag-section container-fluid">
        <div className="bagheader">
          <div className="nav-logo">
            <Link to="/">
              <img
                src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png"
                alt="logo"
              />
            </Link>
          </div>
          <div className="headerCenter">
            <Link to="/bag">BAG -------- </Link>
            <Link to="/address"> ADDRESS -------- </Link>
            <Link to="/payment">PAYMENT</Link>
          </div>
          <div className="headerRight">
            <img
              className="image2"
              src="https://constant.myntassets.com/checkout/assets/img/sprite-secure.png"
              alt="secure"
            />
            <span> 100% SECURE</span>
          </div>
        </div>
      </div>

      {/* PAYMENT PAGE */}
      <div className="container payment-page">
        <div className="payment-left">
          {/* OFFER */}
          <div className="offer-box">
            <strong>Bank Offer</strong>
            <p>
              10% Instant Discount on Axis Bank Credit Card and Credit Card EMI on
              a min spend of ₹3,000. TCA
            </p>
          </div>

          {/* PAYMENT MODES */}
          <div className="payment-modes">
            <strong>Choose Payment Mode</strong>
            <div className="payment-tabs">
              {paymentMethods.map((method) => (
                <div
                  key={method.id}
                  className={`payment-tab ${
                    selectedMethod === method.id ? "active" : ""
                  }`}
                  onClick={() => handleSelect(method.id)}
                >
                  {method.label}
                </div>
              ))}
            </div>

            <div className="payment-option-box">
              <label>
                <input type="radio" checked readOnly />
                {
                  paymentMethods.find((m) => m.id === selectedMethod)?.label
                }
              </label>
            </div>
          </div>
        </div>

        {/* PRICE SUMMARY */}
        <div className="payment-right">
  <div className="secure-tag">✅ 100% SECURE</div>

  {/* CART PRODUCTS */}
  <div className="payment-cart">
    <strong>DELIVERY ESTIMATES</strong>

    {cart.map((item) => (
      <div key={item.cart_id} className="payment-cart-item">
        <img
          src={
            item.parsedImage?.length
              ? `https://cyberathon.com/multivendor/${item.parsedImage[0]}`
              : "https://via.placeholder.com/60"
          }
          alt={item.product_name}
          className="payment-cart-img"
        />

        <div className="payment-cart-info">
          <p className="mb-1">{item.product_name}</p>
          <small>Qty: {item.qty}</small>
          <p className="fw-bold">₹{item.current_price}</p>
        </div>
      </div>
    ))}
  </div>

  <hr />

  {/* PRICE SUMMARY */}
  <div className="price-summary">
    <strong>PRICE DETAILS ({cart.length} Item{cart.length !== 1 ? "s" : ""})</strong>

    <div className="price-row">
      <span>Total MRP</span>
      <span>₹{subtotal}</span>
    </div>

    <div className="price-row">
      <span>Discount on MRP</span>
      <span className="green">-₹{totalDiscount}</span>
    </div>

    <div className="price-row">
      <span>Platform Fee</span>
      <span className="green">FREE</span>
    </div>

    <hr />

    <div className="price-row total">
      <strong>Total Amount</strong>
      <strong>₹{grandTotal}</strong>
    </div>

    <button
      className="place-order-btn"
      onClick={placeOrder}
      disabled={loading}
    >
      {loading ? "PLACING ORDER..." : "PLACE ORDER"}

    </button>
  </div>
</div>
      </div>
    </div>
  );
};

export default PaymentPage;
